import { ReturnStruct } from "src/app/shared/structs/return.struct";

export class PostCpfCnsResponse extends ReturnStruct {
    public cpf: string = '';
    public cns: string = '';
    public name: string = '';
    public socialName: string = '';
    public motherName: string = '';
    public fatherName: string = '';
    public birthDate: Date | null = null;
    public idGender: number | null = null;
    public hasIntegration: boolean = false;
    public token: string = '';
}